module.exports = __webpack_public_path__ + "static/media/referance.64790423.jpg";